export default __webpack_public_path__ + "static/do-links-icon-or-shape-7561ab891c35fcfb3ea39e44e29eeaa8.png";